// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ShippingCarrierSearch } from '@/components/shipping-carrier-search';
import {
  ShippingCarrier,
  isShippingCarrier,
} from '@/constants/shipping-carrier';
import {
  Control,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

interface Props<Values extends FieldValues> extends UseControllerProps<Values> {
  /**
   * The label attached to the input element.
   */
  label: string;

  /**
   * A react-hook-form control object used to connect the input element to the
   * form.
   */
  control: Control<Values>;

  onChange?: (value: ShippingCarrier | null) => void;

  /**
   * If true, the input is disabled.
   */
  disabled?: boolean;
}

/**
 * A controlled carrier search component that integrates with react-hook-form.
 */
export function FormShippingCarrierSearch<Values extends FieldValues>(
  props: Props<Values>
) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control,
  });

  const value = isShippingCarrier(field.value) ? field.value : null;
  const onChange = (value: ShippingCarrier | null) => {
    if (props.onChange) {
      props.onChange(value);
    }
    field.onChange(value);
  };
  return (
    <ShippingCarrierSearch
      ref={field.ref}
      name={field.name}
      label={props.label}
      value={value}
      onChange={onChange}
      error={Boolean(fieldState.error)}
      helperText={fieldState.error?.message}
      disabled={props.disabled}
    />
  );
}
